function Recommendation({
  currencyFormat,
  programId = "gold",
  title = "Recommended",
  monthlyProgramContribution,
  programPersonalResponsibility,
}) {
  const { cct_calculator_labels, cct_chm_programs } = cct_calculator_data;
  const program = cct_chm_programs[programId];
  return (
    <div className={`card card--${programId}`} data-program-id={programId}>
      <div className="card__banner">
        <h2 className="card__banner-title">
          <strong>{title}</strong> CHM Program
        </h2>
      </div>
      <div className="card__content">
        <div className="card__column">
          <div className="chm-program">
            <div className="chm-program__title">
              <h3 className="chm-program__title__heading">{program.name}</h3>
              {programId !== "seniorshare" && (
                <>
                  <span className="chm-program__title__image" dangerouslySetInnerHTML={{ __html: program.icon }}></span>
                  <span className="chm-program__title__subheading">with CHM Plus</span>
                </>
              )}
            </div>
            <div className="chm-program__description">
              <p>{program.short_program_description}</p>
            </div>
            <div className="chm-program__financials">
              <div className="chm_program__financials__row">
                <div className="chm-program__financials__description">
                  {cct_calculator_labels["monthly_contribution"]["input_label"]}{" "}
                  {cct_calculator_labels["monthly_contribution"]["input_description"] && (
                    <span
                      class="calculator-tooltip"
                      data-tooltip={cct_calculator_labels["monthly_contribution"]["input_description"]}
                    >
                      <i class="fa-regular fa-circle-info"></i>
                    </span>
                  )}
                </div>
                <div className="chm-program__financials__amount">
                  {Intl.NumberFormat("en-US", currencyFormat).format(monthlyProgramContribution)}
                </div>
              </div>
              <div className="chm_program__financials__row">
                <div className="chm-program__financials__description">
                  {cct_calculator_labels["minimum_amount_to_qualify"]["input_label"]}{" "}
                  {cct_calculator_labels["minimum_amount_to_qualify"]["input_description"] && (
                    <span
                      class="calculator-tooltip"
                      data-tooltip={cct_calculator_labels["minimum_amount_to_qualify"]["input_description"]}
                    >
                      <i class="fa-regular fa-circle-info"></i>
                    </span>
                  )}
                </div>
                <div className="chm-program__financials__amount">{program.details.shared_expense}</div>
              </div>
              <div className="chm_program__financials__row">
                <div className="chm-program__financials__description">
                  {cct_calculator_labels["personal_responsibility"]["input_label"]}{" "}
                  {cct_calculator_labels["personal_responsibility"]["input_description"] && (
                    <span
                      class="calculator-tooltip"
                      data-tooltip={cct_calculator_labels["personal_responsibility"]["input_description"]}
                    >
                      <i class="fa-regular fa-circle-info"></i>
                    </span>
                  )}
                </div>
                <div className="chm-program__financials__amount">
                  {Intl.NumberFormat("en-US", currencyFormat).format(programPersonalResponsibility)}
                </div>
              </div>
              <div className="chm_program__financials__row">
                <div className="chm-program__financials__description">
                  {cct_calculator_labels["maximum_per_illness"]["input_label"]}{" "}
                  {cct_calculator_labels["maximum_per_illness"]["input_description"] && (
                    <span
                      class="calculator-tooltip"
                      data-tooltip={cct_calculator_labels["maximum_per_illness"]["input_description"]}
                    >
                      <i class="fa-regular fa-circle-info"></i>
                    </span>
                  )}
                </div>
                <div className="chm-program__financials__amount">
                  {program.lifetime_maximum_per_illness_with_chm_plus}
                </div>
              </div>
            </div>
            <p>
              <small>{program.program_cost_explainer_text}</small>
            </p>
          </div>
        </div>
        <div className="card__column">
          <div className="chm-program__offerings">
            <h3 className="chm-program__offerings__title">Membership Benefits</h3>
            {program.program_offerings.map((offering) => {
              return (
                <div className="chm-program__offerings__row">
                  <div className="chm-program__offerings__image">
                    {offering.offering_icon && (
                      <img className="chm-program__offerings__image" src={offering.offering_icon} alt="" />
                    )}
                  </div>
                  <div className="chm-program__offerings__col">
                    <h4 className="chm-program__offerings__name">{offering.offering_title}</h4>
                    <p className="chm-program__offerings__description">{offering.offering_description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
